export const YANDEX_FOOD_CATALOG_ID = '404';
